import type { EmailMessageTypeAll } from 'shared-types';
import type { ReduxRootState } from 'types';

const getEmailLogTypes = ({
  messages
}: {
  messages: ReduxRootState['messages'];
}): Record<EmailMessageTypeAll, string> => ({
  'account-expiration-warning': messages.emailTypeAccountExpirationWarning,
  'achievement-access-request-accept':
    messages.achievementRequestAchievementGranted,
  'achievement-access-request-deny':
    messages.achievementRequestAchievementDenied,
  'achievement-expired': messages.emailTypeExternalAchievementExpired,
  'achievement-expiring': messages.emailTypeExternalAchievementExpiring,
  'achievement-expiration-others':
    messages.emailTypeExternalAchievementExpirationOthers,
  'achievement-individual-request-denied':
    messages.achievementIndividualRequestDenied,
  'achievement-individual-request-granted':
    messages.achievementIndividualRequestGranted,
  'achievement-individual-request-new':
    messages.emailTypeAchievementIndividualRequestNew,
  'achievement-request-achievement-denied':
    messages.achievementRequestAchievementDenied,
  'achievement-request-achievement-granted':
    messages.achievementRequestAchievementGranted,
  'achievement-request-conversation-notes-denied':
    messages.achievementRequestConversationNotesDenied,
  'achievement-request-conversation-notes-granted':
    messages.achievementRequestConversationNotesGranted,
  'achievement-request-milestone-denied':
    messages.achievementRequestMilestoneDenied,
  'achievement-request-milestone-granted':
    messages.achievementRequestMilestoneGranted,
  'achievement-request-task-list-denied':
    messages.achievementRequestTaskListDenied,
  'achievement-request-task-list-granted':
    messages.achievementRequestTaskListGranted,
  'achievement-supervisor-added-to-achievement':
    messages.achievementSupervisorAddedToAchievement,
  'achievement-supervisor-added-to-conversation-notes':
    messages.achievementSupervisorAddedToConversationNotes,
  'achievement-supervisor-added-to-group-conversation':
    messages.achievementSupervisorAddedToGroupConversation,
  'achievement-supervisor-added-to-milestone':
    messages.achievementSupervisorAddedToMilestone,
  'achievement-supervisor-added-to-task-list':
    messages.achievementSupervisorAddedToTaskList,
  'calendar-event-access': messages.emailTypeCalendarEventAccess,
  'calendar-event-access-request': messages.emailTypeCalendarEventAccessRequest,
  'calendar-event-access-request-accept':
    messages.emailTypeCalendarEventAccessRequestAccept,
  'calendar-event-access-request-deny':
    messages.calendarEventAccessRequestDenied,
  'calendar-event-canceled': messages.emailTypeCalendarEventCanceled,
  'calendar-event-feedback-request':
    messages.emailTypeCalendarEventFeedbackRequest,
  'calendar-event-fill-from-queue':
    messages.emailTypeCalendarEventFillFromQueue,
  'calendar-event-participation': messages.calendarEventParticipation,
  'calendar-event-registration-confirmation':
    messages.emailTypeCalendarEventRegistration,
  'calendar-event-registration-confirmation-for-others':
    messages.emailTypeCalendarEventRegistrationConfirmationForOthers,
  'calendar-event-registration-queued':
    messages.emailTypeCalendarEventRegistrationQueued,
  'calendar-event-registration-queued-for-others':
    messages.emailTypeCalendarEventRegistrationQueuedForOthers,
  'calendar-event-settings-changed':
    messages.emailTypeCalendarEventSettingsChanged,
  'completion-expired': messages.emailTypeCompletionExpired,
  'completion-expiring': messages.emailTypeCompletionExpiring,
  'completion-expiration-others': messages.emailTypeCompletionExpirationOthers,
  'course-access': messages.emailTypeCourseAccess,
  'course-access-request': messages.emailTypeCourseAccessRequest,
  'course-access-request-accept': messages.emailTypeCourseAccessRequestAccept,
  'course-access-request-deny': messages.emailTypeCourseAccessRequestDeny,
  'course-completed': messages.emailTypeCourseCompleted,
  'course-deadline-approaching': messages.emailTypeCourseDeadlineApproaching,
  'course-deadline-email-list': messages.emailTypeCourseDeadlineEmailList,
  'course-deadline-passed': messages.emailTypeCourseDeadlinePassed,
  'course-summary': messages.emailTypeCourseSummary,
  'create-account': messages.createAccount,
  'custom-email': messages.emailTypeCustomEmail,
  'delete-request': messages.emailTypeDeleteRequest,
  'delete-request-success': messages.emailTypeDeleteRequestSuccess,
  'group-invite': messages.emailTypeGroupInvite,
  'new-user': messages.emailTypeNewUser,
  'password-expiring': messages.emailTypePasswordExpiring,
  'open-question-comment': messages.emailTypeOpenQuestionComment,
  'open-question-request-changes': messages.emailTypeOpenQuestionRequestChanges,
  'open-question-review': messages.emailTypeOpenQuestionReview,
  'path-completed': messages.emailTypePathCompleted,
  'path-deadline-approaching': messages.emailTypePathDeadlineApproaching,
  'path-deadline-email-list': messages.emailTypePathDeadlineEmailList,
  'path-deadline-expired': messages.emailTypePathDeadlineExpired,
  'path-invite': messages.emailTypePathInvite,
  register: messages.emailTypeRegister,
  'path-summary': messages.emailTypePathSummary,
  'profile-summary-email': messages.profileSummaryEmailSubject,
  'reset-password': messages.emailTypeResetPassword,
  'supervisor-achievement-add': messages.emailTypeSupervisorAchievementAdd,
  'supervisor-summary': messages.supervisorSummaryEmail,
  'user-answers': messages.emailTypeUserAnswers,
  'user-certificate': messages.emailTypeUserCertificate,
  'user-custom-attributes-notification':
    messages.emailTypeUserCustomAttributesNotification,
  'vuoadmin-login': messages.authVuoadminLogin
});

export default getEmailLogTypes;
